import styled from 'styled-components';

export const GridWrapper = styled.div`
    width: 100%;
    height: 47vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.isAdmin ? '#133666' : '#ddd'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-size: 13px;
    }

    .ag-header-row {
        color: ${p => p.isAdmin ? 'white' : '#123'} !important;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 30px;
        border-color: #ccc;
        font-size: 13px;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .list-cell > .ag-cell-wrapper > .ag-cell-value,
    .list-cell > .ag-cell-wrapper > .ag-cell-value > .ag-react-container {
        width: 100%;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
        padding-bottom: 5px;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customSortDownLabel {
        margin-left: 3px;
    }

    .customSortUpLabel {
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .ag-react-container {
        text-align: center;
    }
`;